module.exports = __webpack_public_path__ + "img/lunas.fc97790f.svg";